/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraDataCenterIssueType {
    getFixupPrototypeFunction() { return JiraDataCenterIssueType.fixupPrototype; }

    static newInstance(model: Partial<JiraDataCenterIssueType>): JiraDataCenterIssueType {
        let obj = Object.assign(new JiraDataCenterIssueType(), model);
        JiraDataCenterIssueType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraDataCenterIssueType>): JiraDataCenterIssueType {
        if (!model) return null;
        return JiraDataCenterIssueType.newInstance(<JiraDataCenterIssueType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraDataCenterIssueType) {
        if (!obj) return;

        models.JiraDataCenterIssueType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraDataCenterIssueType): boolean {
        Object.setPrototypeOf(obj, JiraDataCenterIssueType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.avatarId === undefined) {
            this.avatarId = 0;
        }
    }

    /**
     * Attribute of the JIRA issue
     */
    item: string;

    /**
     * ID of the Issue
     */
    item_id: string;

    /**
     * Description of the Issue
     */
    description: string;

    /**
     * Icon URL of the Issue
     */
    iconUrl: string;

    /**
     * Name of the Issue
     */
    name: string;

    /**
     * Subtask of the issue
     */
    subtask: string;

    /**
     * Avatar ID of the issue
     */
    avatarId: number;

}
